import { fg } from '@atlaskit/platform-feature-flags/fg';

type IsInlineMacroPresentationInput = {
	isEditing?: boolean;
	layout: unknown;
};

/**
 * TODO: Simplify this helper when `platform_forge_inline_bodied_layout_switch` and
 * `platform_forge_inline_bodied_macro` are cleaned up. Inline-bodied presentation will
 * then only need to check the layout and edit state.
 */
export const isInlineMacroPresentation = ({
	isEditing,
	layout,
}: IsInlineMacroPresentationInput): boolean =>
	layout === 'inline' ||
	(layout === 'inline-bodied' &&
		!isEditing &&
		fg('platform_forge_inline_bodied_layout_switch') &&
		fg('platform_forge_inline_bodied_macro'));
